<template>
  <FeatureGuard feature="solutions">
    <div>
      <div v-if="!$route.params.solutionId" class="viewsolution_list">
        <div v-for="(item, index) in listItems" :key="index" class="list-item">
          <router-link :to="item.href">
            <span :class="item.type" class="icon"></span>
            <span>{{ item.title }}</span>
          </router-link>
        </div>
      </div>
      <router-view :list-items="listItems" :list-name="listName" :parent-title="parentTitle">
      </router-view>
    </div>
  </FeatureGuard>
</template>

<script lang="ts">
import Vue, { defineComponent, PropType } from "vue";
import FeatureGuard from "@/components/FeatureGuard.vue";

interface ListItem {
  title: string;
  href: string;
  type: string;
}

export default defineComponent({
  name: "ViewSolutionListing",
  components: { FeatureGuard },
  props: {
    listItems: {
      type: Array as PropType<ListItem[]>,
      default: () => [],
    },
    listName: {
      type: String,
    },
    parentTitle: {
      type: String,
    },
  },
});
</script>

<style lang="scss">
@import "../design-system/assets/tokens/tokens";
.viewsolutionlisting_section {
  .note {
    padding-top: 40px;
    font-size: 18px;
  }
  .breadcrumb-container {
    margin-bottom: 48px;
  }

  .border-box {
    .box-header {
      font-size: 32px;
      line-height: 40px;
      font-weight: $weight-bold;
      margin-top: 0;
      margin-bottom: 14px;
    }
    .description {
      font-size: 16px;
      font-weight: $weight-normal;
      color: $color-iloq-gray-dark;
    }
    .viewsolution_list .list-item {
      padding: 24px 0 20px;
      a {
        text-decoration: none;
        font-size: 15px;
        font-weight: $weight-bold;
        .icon {
          display: inline-block;
          background: url("/img/components/icons/folder.svg") no-repeat scroll center center;
          background-size: 16px 16px;
          margin: 0 10px -3px 0;
          padding: 0;
          width: 16px;
          height: 16px;
          border: none;
          &.article {
            background: url("/img/components/icons/article.svg") no-repeat scroll center center;
          }
          &.video {
            background: url("/img/components/icons/video.svg") no-repeat scroll center center;
          }
        }
      }
      border-bottom: 1px solid $color-iloq-gray-light;
    }
    :last-child {
      border-bottom: none;
    }

    font-size: $size-ms;
    .input___wrapper input {
      font-size: $size-ms;
    }
    .textarea textarea {
      font-size: $size-ms;
    }
  }
}
</style>
